const services = [
  {
    icon: 'ri-building-4-line',
    title: 'Kantoorreiniging',
    description: 'Dagelijkse of wekelijkse schoonmaak van kantoren en bedrijfspanden. Van werkplekken tot vergaderruimtes — alles brandschoon en representatief.',
  },
  {
    icon: 'ri-window-line',
    title: 'Glasbewassing',
    description: 'Professionele glasbewassing voor binnen en buiten. Streeploos schone ramen voor een heldere uitstraling van uw bedrijfspand.',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Winkel- & Retailreiniging',
    description: 'Schoonmaak op maat voor winkels en winkelcentra. Wij houden uw verkoopvloer, etalages en sanitaire ruimtes fris en uitnodigend voor klanten.',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Horecareiniging',
    description: 'Hygiënische schoonmaak voor restaurants, cafés en hotels. Wij voldoen aan de strenge HACCP-richtlijnen voor een veilige werkomgeving.',
  },
  {
    icon: 'ri-hospital-line',
    title: 'Zorginstellingen',
    description: 'Gespecialiseerde reiniging voor zorginstellingen, huisartsenpraktijken en tandartspraktijken. Hygiëne staat hier op de allerhoogste prioriteit.',
  },
  {
    icon: 'ri-brush-line',
    title: 'Vloerreiniging & Onderhoud',
    description: 'Professionele reiniging en onderhoud van alle vloertypes — tapijt, parket, tegels, PVC en meer. Verlengt de levensduur van uw vloeren aanzienlijk.',
  },
];

export default function ServicesSection() {
  return (
    <section id="diensten" className="relative py-24 md:py-32 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">
            Onze diensten
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-5">
            Alles voor een{' '}
            <span className="text-primary-500">frisse werkomgeving</span>
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            Van kantoor tot zorginstelling — wij bieden een compleet pakket aan schoonmaakdiensten voor elke branche.
            Altijd met professionele schoonmakers en oog voor detail.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="group bg-background-50 rounded-2xl p-8 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300 mb-5">
                <i className={`${service.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}